module.exports = __webpack_public_path__ + "static/img/withdraw.5fe7a9f6.png";